/* External */
import {
  memo,
  useMemo,
} from 'react';
import { FormattedMessage } from 'react-intl';

/* Providers */
import { useDeviceInfo } from '../../../providers/DeviceInfoProvider';

/* Utils */
import platform from '../../../utils/platform';
import { APP_VERSION } from '../../../utils/env';

function SystemInfo() {
  const { modelName, sdkVersion } = useDeviceInfo() || {};

  const systemInfo = useMemo(
    () => (
      [
        {
          label: 'appVersion',
          value: APP_VERSION,
        },
        {
          label: 'tvModelName',
          value: modelName || 'N/A',
        },
        {
          label: 'osVersion',
          value: (platform.osName && sdkVersion)
            ? `${platform.osName} ${sdkVersion}`.trimStart()
            : 'N/A',
        },
      ]
    ),
    [modelName, sdkVersion],
  );

  return (
    <div className="dtv-html5-c-setting__app-info">
      {
        systemInfo.map(({ label, value }) => (
          <p key={label}>
            <FormattedMessage id={`settings.info.${label}`} />
            :
            {' '}
            {value}
          </p>
        ))
      }
    </div>
  );
}

export default memo(SystemInfo);
